import { useEffect, useRef, useCallback } from "react";
import HeroCanvas from "./PagesComps/HeroCanvas";
import { useNotFoundPage } from "../data/content";
import Emphasis from "../components/Emphasis";

function NotFound({ darkMode }) {
  const page = useNotFoundPage();
  const mouseRef = useRef({ x: 0, y: 0 });

  const handleMouseMove = useCallback((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    mouseRef.current = {
      x: ((e.clientX - rect.left) / rect.width) * 2 - 1,
      y: -((e.clientY - rect.top) / rect.height) * 2 + 1,
    };
  }, []);

  useEffect(() => {
    if (page.documentTitle) document.title = page.documentTitle;
  }, [page.documentTitle]);

  return (
    <main
      className="min-h-screen bg-background-light dark:bg-background-dark flex items-center justify-center px-6 relative overflow-hidden"
      onMouseMove={handleMouseMove}
    >
      <HeroCanvas mouseRef={mouseRef} darkMode={darkMode} />

      <div className="relative z-10 text-center">
        <p className="font-sans text-xs tracking-[0.3em] uppercase text-text-muted-light dark:text-text-muted-dark mb-6">
          {page.eyebrow}
        </p>
        <h1 className="font-sans font-bold text-5xl md:text-7xl text-text-primary-light dark:text-text-primary-dark leading-tight">
          <Emphasis>{page.heading}</Emphasis>
        </h1>
        <p className="font-sans text-base text-text-muted-light dark:text-text-muted-dark max-w-sm mx-auto leading-relaxed mt-4">
          {page.blurb}
        </p>
      </div>
    </main>
  );
}

export default NotFound;
